module.exports = __webpack_public_path__ + "img/Flag_of_Andorra.ac3cdb5b.svg";